/**
 * Адрес вебсокета чата — из адреса API, а не из адреса страницы (02.10.2026, сборка 1.1.1).
 *
 * ⚠️ ЗАЧЕМ. Адрес собирался из `window.location`: на сайте страница и API живут на одном хосте, и это работало.
 * В приложении страница живёт на `capacitor://localhost` (iOS) и `https://localhost` (Android) — выходило
 * `ws://localhost/…` и `wss://localhost/…`, до сервера такой запрос не доходит. У куратора в приложении сокет был
 * сломан с первой сборки. REST этим не страдал: у него база абсолютная (`VITE_API_BASE_PATH` в `.env.mobile`).
 *
 * База та же, что у REST: относительная `/api/v1` на сайте даёт прежний хост страницы, абсолютная в приложении —
 * хост API.
 *
 * ⚠️ Сокет идёт мимо CapacitorHttp: привязка сертификата (pinning) его не закрывает.
 */
const BASE_PATH = import.meta.env.VITE_API_BASE_PATH || '/api/v1';

export function chatSocketUrl(token: string, base: string = BASE_PATH, here: string = window.location.href): string {
  const api = new URL(base, here);
  // Незашифрованный сокет — только там, где и сам API открыт по http (разработка). Всё остальное — wss.
  const proto = api.protocol === 'http:' ? 'ws:' : 'wss:';
  const path = api.pathname.replace(/\/+$/, '');
  return `${proto}//${api.host}${path}/chat/ws?token=${encodeURIComponent(token)}`;
}
